import axios from '@/plugins/axios.js';

const state = {
  token: localStorage.getItem('token') || '',
  user: {
    name: null,
  },
  isAuthenticated: localStorage.getItem("token") !== null,
  permissions: {
    sales: {
      path: '/sales',
      status: false
    },
    posventa: {
      path: '/posventa',
      status: false
    },
    services: {
      path: '/services',
      status: false
    },
    checkin: {
      path: '/checkin',
      status: false
    },
    vehicles: {
      path: '/vehicles',
      status: false
    },
    clients: {
      path: '/clients',
      status: false
    },
    resources: {
      path: '/resources',
      status: false
    },
    home: {
      path: '/',
      status: false
    },
    admin: {
      path: '/admin',
      status: false
    },
  },
};

const getters = {
  isAuthenticated: (state) => !!state.token,
  getUser: (state) => state.user,
  role: (state) => state.user?.role || null,
  getToken: (state) => state.token,
  permissions: (state) => state.permissions,
};

const mutations = {
  setToken(state, token) {
    state.token = token;
    localStorage.setItem('token', token);
  },
  /*setUser(state, user) {
    state.user = user;
    localStorage.setItem('user', JSON.stringify(user));
  },*/
  logout(state) {
    state.token = '';
    state.user = null;
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    return new Promise((resolve, reject) => {
      axios.post("/logout"
      ).then(res => {
        resolve(res);
      }).catch(error => {
        reject(error);
      })
    })

  },
  setAuthentication(state, status) {
    state.isAuthenticated = status;
  },
  updatePermission(state, obj) {
    //this.updatePermission({ permission: permissionName, status : true });
    if (state.permissions.hasOwnProperty(obj.permission)) {
      state.permissions[obj.permission].status = obj.status;
    }
  },
  setUser(state, user) {
    state.user = user;
  },
};

const actions = {
  /*login({ commit }, { token, user }) {
    commit('setToken', token);
    commit('setUser', user);
  },*/
  logout({ commit }) {
    commit('logout');
  },
  async login({ commit }, { email, password }) {
    return new Promise((resolve, reject) => {
      localStorage.removeItem("token");
      axios.post("/login", {
        email: email,
        password: password,
        token_notification: ''
      }).then(res => {

        if (res.status == 200) {
          // Almacenar el token en localStorage
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + res.data.token;
          //localStorage.setItem("token", res.data.token);
          commit('setToken', res.data.token);
          commit('setAuthentication', true);
          commit('setUser', res.data.user);
          //Actualizamos los permisos
          //commit('clearPermissions');
          res.data.user.roles[0].permissions.forEach((permission) => {
            const permissionName = permission.name;
            commit('updatePermission', { permission: permissionName, status: true });
          });

        }
        resolve(res);
      }).catch(error => {
        //console.error("Error during login:");
        //console.error(error.response.data.msg);
        reject(error);
      })
    })

  },
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post("/logout"
      ).then(res => {
        resolve(res);
      }).catch(error => {
        reject(error);
      })
    })
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};